// import { PaymentMethods, PaymentMethodsTranslate } from '@/enums';
import { Actions } from 'vuex-smart-module';
import { ResponseStatuses, RepairStatuses } from '@/enums';
import { Filters, FiltersPagination } from '@/types';
import { AxiosResponse } from 'axios';
import { Repairs } from '@/modules/repairs/types';
import { RepairsService } from '../../../services';
import WarrantyGetters from './getters';
import WarrantyMutations from './mutations';
import WarrantyState from './state';

const repairsService = new RepairsService();

export default class WarrantyActions extends Actions<
  WarrantyState,
  WarrantyGetters,
  WarrantyMutations,
  WarrantyActions
> {
  // получение данных о гарантии с сервера
  async check_warranty(id: string | number) {
    this.mutations.TOGGLE_LOADING_WARRANTY(true);

    try {
      const { data, code } = await repairsService.check_warranty(id);

      this.mutations.SET_WARRANTY_DATA(data);
      return code;
    } catch (error) {
      console.log(error);
      return (error as AxiosResponse).status;
    } finally {
      this.mutations.TOGGLE_LOADING_WARRANTY(false);
    }
  }
}
